<template>
  <div class="modal-window bds067">
    <header class="modal-header">
      <!-- <div class="tit">표 추가</div> -->
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>
    <div class="modal-content">
      <div class="info-txt">{{ $i18nUtil.trans("title.URLModal.001","링크추가") }}</div>
      <div class="content">
        <input name="address"
          v-model="urlAddress"
          @focus="onFocus" @keydown="onKey" @keyup="onKey"
          :placeholder="$i18nUtil.trans('message.URLModal.001','URL을 입력하세요')"/>
      </div>
      <div class="message" v-if="errmsg">
        {{errmsg}}
      </div>
      <div class="metadata" v-if="meta.length > 0">
        <div class="meta_image" v-if="meta[0].image">
          <img :src="meta[0].image"/>
        </div>
        <div class="meta_url" v-if="meta[0].url">
          <a :href="meta[0].url">{{meta[0].url}}</a>
        </div>
        <div class="meta_title">{{meta[0].title}}</div>
        <div class="meta_desc">{{meta[0].description}}</div>
      </div>
    </div>
    <footer class="modal-footer">
      <br/>
      <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.register","등록") }}</button>
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    name: { type: String, },
    modalInfo: { type:Object },
  },
  data() {
    return {
      urlAddress: "",
      urlContent: "",
      meta: [ ],
      state: { },
      errmsg: "",
    };
  },
  mounted() {
    if (this.modalInfo.content) {
      this.urlAddress = this.modalInfo.content;
    }
  },
  methods: {
    onFocus(e) {
      this.errmsg = "";
      let target = e.target;
      let name = target.getAttribute("name");
      if (name === "address") {
        // if (!this.urlAddress) {
        //   this.urlAddress = "http://";
        // }
      }
    },
    onKey(e) {
      let etype = e.type;
      let target = e.target;
      let key = e.keyCode;
      let name = target.getAttribute("name");
      let value = target.value;
      this.errmsg = "";

      if (etype === "keydown" && key == 13) {
        if (name === "address") {
          this.meta.splice(0, 1);
          this.getLinkMeta(value);
        }
      }
    },
    validate(url) {
      let test = /^(http|https):\/\/([a-zA-Z0-9_.:-]+)(\/.*){0,1}$/;
      return test.exec(url);
    },
    onClickSubmit() {
      if (!this.urlAddress) {
        this.errmsg = this.$i18nUtil.trans("UB004");
        console.log(this.$i18nUtil.trans("UB004"));
      }
      else if (!this.validate(this.urlAddress)) {
        this.errmsg = this.$i18nUtil.trans("message.URLModal.003","정상적인 URL을 입력해 주세요 (예: http://www.hanwha.com)");
        console.log(this.$i18nUtil.trans("UB004"));
      }
      else {
        if (!this.meta[0]) {
          if (!this.state.working) {
            this.getLinkMeta(this.urlAddress);
            this.state.working = true;
          }
          setTimeout(this.onClickSubmit, 500);
        } else {
          this.state.working = false;
          this.modalInfo.fnSubmit(this.modalInfo.blockType, this.urlContent);
          this.$emit("close");
        }
      }
    },
    getLinkMeta(link) {
      let url = "/api/copaper/paperblock/getLinkMeta";
      let param = { link: link };
      axios
        .post(url, param)
        .then((res) => {
          let result = {};
          if (res.data.result) { result = res.data.result; }
          if (result.data && Object.keys(result.data).length > 0) {
            let data = result.data;
            this.urlContent = "<a " + 
              (data.title ? "data-meta-title=\"" + data.title + "\" " : "") +
              (data.image ? "data-meta-image=\"" + data.image + "\" " : "") +
              (data.description ? "data-meta-description=\"" + data.description + "\" " : "") +
              (data.linkType ? "data-meta-linkType=\"" + data.linkType + "\" " : "") +
              ">" + link + "</a>";
            this.meta.splice(0, 1, result.data);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    }
  },
};
</script>

<style scoped>

div.metadata {
  margin: 5px 25px;
}

div.meta_image {
  position: relative;
  overflow: hidden;
  width: 62px;
  height: 62px;
  border: 1px solid #777;
  padding: 2px;
  float: left;
  margin-right: 15px;
}

div.meta_image > img {
  position: absolute;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 60px;
  max-height: 60px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

div.meta_url {
  padding: 5px 0 5px 0;
}

.modal-footer {
  clear: both;
}

.content {
  width: 90%;
  margin: 15px auto 0 auto;
}
.content input {
  width: 100%;
  height: 40px;
  padding: 0 10px 0 10px;
  border: 1px solid #555;
}

.message {
  margin-left: 27px;
  color: #f00;
}

</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/URLModal.vue